import styled from "styled-components";

export const ExerciseInfo = styled.div`
  display: flex;
  width: calc(100vw - 32px);
  height: 80px;
  padding: 0 20px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 40px;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${(props) => props.theme.shadows.box};
`;

export const ExerciseInfoTxt = styled.div`
  display: flex;
  padding: 0 10px;
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.6rem;
  font-weight: 600;
  flex-direction: column;
  gap: 4px;

  span {
    font-weight: 500;
  }
`;

export const InfoTime = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.primary100};
  font-size: 1.2rem;
  align-items: center;
  gap: 3px;
`;

export const PlayBtn = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.primary5};
  border: none;
  border-radius: 50%;

  &:active {
    background: ${(props) => props.theme.colors.primary12};
  }
`;
